export const getRootDomainFromHost = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');

  if (parts.length <= 2) return hostname;

  return parts.slice(-2).join('.');
};
